import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MuiTooltip from '@material-ui/core/Tooltip';
import { Typography } from '@material-ui/core';
import AcceptedContentTooltip from './AcceptedContentTooltip';

const tentativeEventBorder = {
  borderColor: '#C13131',
};

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    fontSize: '14px',
    lineHeight: 1,
    marginTop: '10px',
    borderLeft: 'solid 3px',
    paddingLeft: '5px',
    color: 'rgba(0, 0, 0, 0.65)',
  },
  eventTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    margin: '0px',
  },
  eventType: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    margin: '0px',
  },
  eventTimeRange: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    margin: '0px',
  },
  declinedEventText: {
    textDecoration: 'line-through',
  },
  statusText: {
    textTransform: 'capitalize',
  },
});

const EventContent = ({
  className,
  classes,
  meetingTypeLabel,
  border,
  eventTitle,
  bestNextSteps,
  timeRange,
  status,
}) => {
  return (
    <MuiTooltip
      arrow
      title={status === 'accepted' ? (
        <AcceptedContentTooltip eventTitle={eventTitle} bestNextSteps={bestNextSteps} timeRange={timeRange} />
      ) : (
        <Typography className={classes.statusText}>{status}</Typography>
      )}
    >
      <div
        className={classNames(className, classes.root)}
        style={status === 'tentative' ? tentativeEventBorder : border}
      >
        <p className={classNames(classes.eventTitle, {
          [classes.declinedEventText]: status === 'declined',
        })}
        >
          {eventTitle}
        </p>
        <p className={classNames(classes.eventType, {
          [classes.declinedEventText]: status === 'declined',
        })}
        >
          {meetingTypeLabel}
        </p>
        <p className={classNames(classes.eventTimeRange, {
          [classes.declinedEventText]: status === 'declined',
        })}
        >
          {timeRange}
        </p>
      </div>
    </MuiTooltip>
  );
};

EventContent.defaultProps = {
  className: '',
};

EventContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  meetingTypeLabel: PropTypes.string.isRequired,
  border: PropTypes.object.isRequired,
  eventTitle: PropTypes.string.isRequired,
  bestNextSteps: PropTypes.array.isRequired,
  timeRange: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};

export default withStyles(styles)(EventContent);
